import { useEffect, useState } from "react";
import { Award } from "lucide-react";
import { api } from "@/lib/api";
import { t } from "@/lib/i18n";

const STYLE = {
  1: "bg-gradient-to-r from-[#C59B27] to-[#E2BE52] text-white",
  2: "bg-[#E9EEF0] text-[#4A5A63]",
  3: "bg-[#F3E1D4] text-[#8A4B2A]",
};
const LABEL = { 1: "Top contributor", 2: "2nd top contributor", 3: "3rd top contributor" };

export const ContributorBadge = ({ personId }) => {
  const [me, setMe] = useState(null);
  useEffect(() => {
    api.get("/contributors").then(({ data }) => setMe(data.find((c) => c.person_id === personId) || null));
  }, [personId]);
  if (!me) return null;
  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium shadow-sm ${STYLE[me.rank]}`}
      title={`${me.stories} ${t(me.stories === 1 ? "story" : "stories")} · ${me.members} ${t(me.members === 1 ? "member added" : "members added")}`} data-testid="contributor-badge">
      <Award className="w-4 h-4" />{t(LABEL[me.rank])}
      <span className="font-mono text-[11px] opacity-80" data-testid="contributor-badge-counts">· {me.stories} {t(me.stories === 1 ? "story" : "stories")} · {me.members} {t(me.members === 1 ? "member added" : "members added")}</span>
    </span>
  );
};
